import $ from "jquery";
import "bootstrap/dist/js/bootstrap.bundle.min.js";

window.jQuery = window.$ = $;

export default $;
